module.exports = __webpack_public_path__ + "img/img_10.7045c622.png";